
import { UseMutationResult } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { createContext } from "react";

import { UpdateMonthBudgetCapPayload, UpdateMonthBudgetCapResponse } from "./ClientBudgetMonthProvider";

import { GetClientBudgetMonthResponse } from "@/types/response/GetClientBudgetMonthResponse";
import { ValidationErrorResponse } from "@/types/response/ValidationResponse";

export type ClientBudgetMonthContextType = {
    isLoading: boolean;
    isFetching: boolean;
    clientBudgetMonth: GetClientBudgetMonthResponse | undefined;
    updateBudgetCap: UseMutationResult<AxiosResponse<UpdateMonthBudgetCapResponse>, AxiosError<ValidationErrorResponse>, UpdateMonthBudgetCapPayload["payload"]>;
}

export const ClientBudgetMonthContext = createContext<ClientBudgetMonthContextType | undefined>(undefined);
